// extracted by mini-css-extract-plugin
module.exports = {"searchBtn":"SearchBtn-module--searchBtn--27UBZ","close":"SearchBtn-module--close--39E90"};